import React from 'react';
import Reveal from '../lib/Reveal.jsx';

const ITEMS = [
  { yr: '2026', title: 'Autonomous evaluation in a specific business domain', domain: 'Applied AI', status: 'In design', collab: 'Columbia University' },
  { yr: '2026', title: 'AI impact on developer productivity', domain: 'Applied AI', status: 'Active', collab: 'Stanford · CMU' },
  { yr: '2026', title: 'Knowledge graphs for grounded enterprise AI', domain: 'Applied AI', status: 'In design', collab: 'Independent' },
  { yr: '2026', title: 'Digital twins as data obfuscation — LLM privacy approach', domain: 'Privacy / AI', status: 'In design', collab: 'Amdocs' },
  { yr: '2025', title: 'Enterprise design for a national CBDC', domain: 'Banking', status: 'Shipped', collab: 'Bank of Israel' },
  { yr: '2025', title: 'Agentic workflows in cross-border payment', domain: 'Cross-border', status: 'Shipped', collab: 'Independent' },
  { yr: '2024', title: 'The Gödel theorem and Walter Benjamin\'s Messiah', domain: 'Theory', status: 'Shipped', collab: 'Tel Aviv University' },
  { yr: '2024', title: 'Cryptocurrencies as digital cultural property', domain: 'Crypto', status: 'Shipped', collab: 'Tel Aviv University' },
  { yr: '2023', title: 'Cognitive embodiment in fitness biofeedback appliances', domain: 'HCI', status: 'Shipped', collab: 'Tel Aviv University' },
  { yr: '2023', title: 'AI in digital mourning and death acceptance', domain: 'Applied AI', status: 'Shipped', collab: 'Tel Aviv University' },
  { yr: '2022', title: 'Evaluation of next-generation core banking platforms', domain: 'Banking', status: 'Shipped', collab: 'PCLabs' },
  { yr: '2021', title: 'A novel approach to cross-border payment platforms', domain: 'Cross-border', status: 'Shipped', collab: 'Vala / independent' },
  { yr: '2020', title: 'Blockchain applied research', domain: 'Blockchain', status: 'Shipped', collab: 'TAU Blockchain Institute' },
  { yr: '2019', title: 'AI strategy for academia and research', domain: 'Applied AI', status: 'Shipped', collab: 'Weizmann Institute of Science' },
];

export default function ResearchIndex({ tweaks }) {
  const statusDot = (s) => s === 'Shipped' ? 'shipped' : 'research';
  return (
    <section id="research" className="section" style={{ background: 'var(--paper-deep)' }}>
      <div className="container">
        <div className="grid12" style={{ marginBottom: 64, alignItems: 'end' }}>
          <Reveal style={{ gridColumn: 'span 6' }}>
            <div className="section-marker" style={{ marginBottom: 24 }}>
              {tweaks.sectionDividers === 'numbered' ? '02 / Research index' : 'Research index'}
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, letterSpacing: '-0.025em', margin: 0, textWrap: 'balance' }}>
              Working notes from the last <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>five years</span>.
            </h2>
          </Reveal>
          <Reveal style={{ gridColumn: '8 / span 5' }}>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: 'var(--ink-60)', margin: 0, maxWidth: '38ch' }}>
              Active research projects and shipped engagements. Status reflects whether the work is still being actively iterated, or has been handed off to the client team.
            </p>
          </Reveal>
        </div>

        <Reveal stagger>
          <div className="row mobile-hide-on-narrow" style={{ gridTemplateColumns: '80px 1fr 200px 160px 120px', gap: 24, padding: '12px 0', border: 'none', background: 'transparent' }}>
            <div className="mono-label">Year</div>
            <div className="mono-label">Title</div>
            <div className="mono-label">Domain</div>
            <div className="mono-label">Collaborator</div>
            <div className="mono-label" style={{ textAlign: 'right' }}>Status</div>
          </div>
          {ITEMS.map((it, i) => (
            <div key={i} className="row mobile-collapse-5" style={{ gridTemplateColumns: '80px 1fr 200px 160px 120px', gap: 24, alignItems: 'center' }}>
              <div className="metric" style={{ fontSize: 14, color: 'var(--ink-60)' }}>{it.yr}</div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, color: 'var(--ink)', lineHeight: 1.3, letterSpacing: '-0.01em' }}>{it.title}</div>
              <div style={{ fontSize: 14, color: 'var(--ink-60)' }}>{it.domain}</div>
              <div style={{ fontSize: 14, color: 'var(--ink-60)', fontStyle: 'italic', fontFamily: 'var(--font-display)' }}>{it.collab}</div>
              <div style={{ textAlign: 'right' }}>
                <span className="pill"><span className={`pill-dot ${statusDot(it.status)}`}></span>{it.status}</span>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
